module.exports = __webpack_public_path__ + "assets/media/day9.461e8576.mp3";